import defaultMascot from "@/assets/img/icon_aimoge.webp";
import { resolveBoardIcon } from "@/shared/lib/boardIcon";

/** 現在URLの板slugに対応するヘッダー画像を返す。 */
export function resolveHeaderMascot(slug: string | null): string {
  return resolveBoardIcon(slug) ?? defaultMascot;
}
